import useSessionVariables from "../components/useSessionVariables.js";
export function getStoredSessionVariables() {
  try {
    const rawModules = sessionStorage.getItem("modules");
    if (!rawModules) {
      return {};
    }

    const parsedModules = JSON.parse(rawModules);
    return {
      modules: parsedModules?.modules ?? parsedModules,
    };
  } catch (error) {
    console.error("Failed to read session modules:", error);
    return {};
  }
}

export function expireSession(sessionObject, message = "Session expired. Please login again.") {
  if (message) {
    localStorage.setItem("authError", message);
  } else {
    localStorage.removeItem("authError");
  }

  if (sessionObject?.clearSessionVariables) {
    sessionObject.clearSessionVariables();
  } else if (sessionObject?.saveSessionVariableByField) {
    sessionObject.saveSessionVariableByField("access_token", "");
  }

  window.location.href = "/";
}

export function normalizeModuleKey(module) {
  if (!module || typeof module !== "string") {
    return "";
  }

  return module.replace(/^\//, "").split("?")[0].trim();
}

export function applySchema(inputDataObject, schemaObject) {
  console.log({ inputDataObject });
  let outputObject = {};
  let newKey = "";
  for (var schemaKey in schemaObject) {
    /**
     * If schema key not present in object skip the same
     */
    if (!(schemaKey in inputDataObject)) {
      continue;
    }
    /**
     * Changing key of output object if needed
     */
    if (schemaObject[schemaKey] == "same") {
      newKey = schemaKey;
    } else {
      newKey = schemaObject[schemaKey];
    }
    /**
     * Converting value of output object to string
     */
    if (typeof inputDataObject[schemaKey] == "object") {
      if (inputDataObject[schemaKey] === null) {
        if (newKey == "input_date" || newKey == "bill_date") {
          outputObject[newKey] = new Date();
        } else {
          outputObject[newKey] = "";
        }
      } else {
        outputObject[newKey] = inputDataObject[schemaKey];
      }
    } else {
      outputObject[newKey] = inputDataObject[schemaKey];
    }
  }
  console.log({ outputObject });
  return outputObject;
}

export function checkAccess(module, sessionVariables) {
  const normalizedModule = normalizeModuleKey(module);
  const resolvedSessionVariables = sessionVariables || getStoredSessionVariables();

  if (!normalizedModule) {
    return true;
  }

  if (!resolvedSessionVariables || !resolvedSessionVariables.modules) {
    return true;
  }

  const modules = resolvedSessionVariables.modules;
  
  if (Array.isArray(modules)) {
    return modules.some((mod) => normalizeModuleKey(mod) === normalizedModule);
  }
  
  if (typeof modules === "object") {
    const moduleList = Array.isArray(modules) ? modules : Object.values(modules);

    return moduleList.some((mod) => {
      if (typeof mod === "string") {
        return normalizeModuleKey(mod) === normalizedModule;
      }

      if (!mod || typeof mod !== "object") {
        return false;
      }

      return [
        mod.module_name,
        mod.menu_accessor,
        mod.url,
      ].some((value) => normalizeModuleKey(value) === normalizedModule);
    });
  }
  return false;
}

export async function apiFetch(endpoint, options = {}, sessionObject) {
  try {
    const token = sessionObject.sessionVariables.access_token;
    const headers = {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
    };

    const config = {
      ...options,
      headers,
    };

    const response = await fetch(endpoint, config);

    if (response.status === 401) {
      expireSession(sessionObject);
      return Promise.reject(new Error("Unauthorized"));
    }

    if (response.status === 423) {
      localStorage.setItem("errorPop", true);
      if (sessionObject?.clearSessionVariables) {
        sessionObject.clearSessionVariables();
      } else {
        sessionObject.saveSessionVariableByField("access_token", "");
      }
      window.location.reload();
      return Promise.reject(new Error("Change password"));
    }

    return await response;
  } catch (err) {
    console.error("Error in API request:", err);
    return Promise.reject(err);
  }
}
